import React from 'react';
import { useTranslation } from 'react-i18next';

import '../../../assets/login.css';
import Cookies from 'universal-cookie';

const Header = () => {
  const { t, i18n } = useTranslation();
  const cookies = new Cookies();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
    cookies.set('language', lang);
  };

  return (
    <div className="login-header">
      <div className="container p-2">
        <div className="d-flex justify-content-between">
          <div className="">
            <img src="/assets/images/logo.png" className="logo " alt="logo" />
          </div>
          <div className="d-flex align-items-center">
            <div
              className={
                i18n.language === 'fr'
                  ? 'personal-information-language font-weight-bold link-enable'
                  : 'personal-information-language font-weight-bold link-disable'
              }
              onClick={() => changeLanguage('fr')}
            >
              {t('languages.fr')}
            </div>
            &nbsp;&nbsp;&nbsp; &nbsp;
            <div
              className={
                i18n.language === 'ar'
                  ? 'personal-information-language font-weight-bold link-enable'
                  : 'personal-information-language font-weight-bold link-disable'
              }
              onClick={() => changeLanguage('ar')}
            >
              {t('languages.ar')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
